import {
  type ID,
  ProjectActions,
  selectBlockParent,
  selectBlocksByNode,
} from '@octopus-do/octopus-project-core'
import type { BlockActions } from '@store/blockSaga/actions'
import type { AppState } from '@store/types'
import { getCloneId, getId } from '@store/utils'
import { commitProjectRequest } from '@storeOld/actionCreators'
import { put, select } from 'redux-saga/effects'

export function* duplicateBlock({
  payload,
}: ReturnType<typeof BlockActions.duplicateBlock>) {
  const { canvas }: AppState = yield select()

  const { ids } = canvas.block

  if (!payload && ids.length !== 1) {
    return
  }

  const id = payload ?? ids[0]

  const nodeIds: ID[] = yield select(selectBlockParent(id))
  const nodeId = nodeIds[0]
  const blocksByNodeId: ID[] = yield select(selectBlocksByNode(nodeId))

  const index = blocksByNodeId.indexOf(id) + 1

  const initiator = getId()
  const clonedId = getCloneId(id, initiator)

  yield put(
    commitProjectRequest(
      ProjectActions.blocks.clone({
        initiator,
        id,
      })
    )
  )

  yield put(
    commitProjectRequest(
      ProjectActions.blocks.move({
        ids: [clonedId],
        index,
        nextParentId: nodeId,
      })
    )
  )
}
